import { useContext, useState, useEffect } from "react";

import { MenuContext } from "../../../../contexts/menu.context";
import {
  getCategories,
  addCategoryUtil,
  addItem,
} from "../../../../utils/restaurant-edit";
import "./restOrderMenu.styles.scss";
import ROMItem from "../restOrderMenuItem/restOrderMenuItem.component";
const RestOrderMenu = () => {
  const [menu, setMenu] = useState({});
  const [folders, setFolders] = useState([]);
  const [categories, setCategories] = useState([]);
  const { menuContext, setMenuContext } = useContext(MenuContext);

  useEffect(() => {
    if (menuContext) {
      setMenu(menuContext);
    }
    setCategories(getCategories(folders, menu));
  }, [folders, menu, menuContext]);
  return (
    <div className="restordermenu-container">
      {Object.keys(menu).map((index) => {
        if (index !== "metadata" && index !== "hotelID") {
          return (
            <ROMItem key={index} itemName={index} menuItem={menu[index]} />
          );
        }
      })}
    </div>
  );
};
export default RestOrderMenu;
